import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, Grid, Dimmer, Loader } from 'semantic-ui-react';
import queryString from 'query-string';

import { APP_NAME } from '../../utils/constant';
import { userRegister, registerRequest } from '../../store/actions';

import './auth.scss';

class UserRegistration extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      errorHandling: null,
    };
  }

  async componentDidMount() {
    const { t } = this.props;
    document.title = `${t('auth.pages.user_registration')} | ${APP_NAME}`;
    try {
      const { registerRequest, navigate } = this.props;
      const query = queryString.parse(this.props.location.search);
      await registerRequest(query.req || null, navigate);
      this.form && this.form.reset();
    } catch (err) {
      console.error(err);
    }
  }

  async handleValidSubmit(event, values) {
    try {
      const { requestedRegUser, userRegister, navigate } = this.props;

      const data = {
        userId: requestedRegUser.id,
        firstName: values.firstName,
        surname: values.lastName,
        password: values.password,
      };
      await userRegister(data, navigate);
      this.setState({ notification: true, error: null });
    } catch (err) {
      console.error(err);
      this.setState({ errorHandling: err });
    }
  }

  render() {
    const {
      registerLoading,
      requestedRegUser,
      registerTokenLoading,
      errorHandling,
      t,
    } = this.props;

    return (
      <Grid.Row>
        <Container
          className="right-heading-container"
          loading={registerTokenLoading}
        >
          <Dimmer active={registerTokenLoading} inverted>
            <Loader content={t('common.loading')} />
          </Dimmer>
          {registerTokenLoading ? null : (
            <>
              <label className="headerText">
                {t('auth.user_registration.you_are_invited')}
              </label>
              <br></br>
              <label className="headerDescription">
                {t(
                  'auth.user_registration.you_have_been_invited_please_complete_the_registration_to_continue'
                )}
              </label>
              <br></br>
              {errorHandling ? (
                <label className={'errorBox'}>
                  <label className={'errorBoxContent'}>{errorHandling}</label>
                </label>
              ) : null}
              <AvForm
                className={'form-group-conatiner'}
                ref={(c) => (this.form = c)}
                onValidSubmit={(event, values) =>
                  this.handleValidSubmit(event, values)
                }
                model={{
                  firstName: requestedRegUser.firstName,
                  lastName: requestedRegUser.surname,
                }}
                autoComplete="off"
              >
                <AvField
                  label={t('formulary.first_name')}
                  placeholder={t('formulary.placeholder.enter_first_name')}
                  className="signin-inputs"
                  name="firstName"
                  type="text"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t(
                        'formulary.validation.first_name_required'
                      ),
                    },
                  }}
                  autoComplete="nope"
                />

                <AvField
                  label={t('formulary.surname')}
                  placeholder={t('formulary.placeholder.enter_surname')}
                  className="signin-inputs"
                  name="lastName"
                  type="text"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t('formulary.validation.surname_required'),
                    },
                  }}
                  autoComplete="nope"
                />

                <AvField
                  label={t('formulary.password')}
                  className="signin-inputs"
                  name="password"
                  placeholder={t('formulary.placeholder.7_plus_characters')}
                  type="password"
                  errorMessage={t(
                    'formulary.validation.please_enter_valid_password'
                  )}
                  minLength="7"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t('formulary.validation.password_required'),
                    },
                  }}
                  autoComplete="new-password"
                />

                <Button
                  type="submit"
                  className="btn btn-primary signin-button"
                  loading={registerLoading}
                  disabled={registerLoading}
                >
                  {t('actions.submit')}
                </Button>
              </AvForm>
            </>
          )}
        </Container>
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      registerRequest,
      userRegister,
    },
    dispatch
  );
};

UserRegistration = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UserRegistration));

export default UserRegistration;
